import DescriptionIcon from '@material-ui/icons/Description';
import SettingsIcon from '@material-ui/icons/Settings';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import PeopleIcon from '@material-ui/icons/People';
import PermMediaIcon from '@material-ui/icons/PermMedia';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import glue from '../../glue';
const coreConfig = {
    dashboard: [
        {
            title: 'Tableau de bord',
            href: '/admin',
            icon: EqualizerIcon,
        },
    ],
    pages: [
        {
            title: 'Pages',
            href: '/admin/pages',
            icon: DescriptionIcon,
        },
    ],
    smartform: [
        glue.isSmartFormEnabled() ? {
            title: 'Formulaires',
            href: '/admin/forms/definitions',
            icon: ContactMailIcon,
        } : null
    ],
    mediaExplorer: [
        {
            title: 'Media',
            href: '/admin/medias',
            icon: PermMediaIcon
        }
    ],
    users: [
        {
            title: 'Utilisateurs',
            href: '/admin/users',
            icon: PeopleIcon,
        },
    ],
    settings: [
        {
            title: 'Paramètres',
            href: '/admin/settings',
            icon: SettingsIcon,
        }
    ]
};
export const getCoreNavbar = (key) => {
    var _a;
    return (_a = coreConfig[key]) !== null && _a !== void 0 ? _a : null;
};
export const navbarConfig = [
    {
        subheader: 'Tableau de bord',
        items: getCoreNavbar("dashboard")
    },
    {
        subheader: 'Contenu',
        items: [
            ...getCoreNavbar("pages"),
            ...getCoreNavbar("smartform")
        ],
    },
    {
        subheader: "Media",
        items: getCoreNavbar("mediaExplorer")
    },
    {
        subheader: 'Utilisateurs',
        items: getCoreNavbar("users")
    },
    {
        subheader: 'Paramètres',
        items: getCoreNavbar("settings")
    }
];
//# sourceMappingURL=navConfig.js.map